module.exports = __webpack_public_path__ + "static/media/stockhausen_cats_2.c9efd7fd.jpg";